import { ProductListServiceRow } from "@pdf/export-services/product-information-pages/product-list-pages/product-list-service-row";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { jsPDF } from "jspdf";

enum Headers {
  NUMBER,
  TITLE,
  DESCRIPTION,
  ID,
  TOTAL_PRICE,
}

function getLocalized(header: Headers): string {
  switch (header) {
    case Headers.NUMBER:
      return $localize`:@@pdfExport.servicesList.tableHeader.number:Nr.`;
    case Headers.TITLE:
      return $localize`:@@pdfExport.servicesList.tableHeader.title:Art`;
    case Headers.DESCRIPTION:
      return $localize`:@@pdfExport.servicesList.tableHeader.description:Anmerkungen`;
    case Headers.ID:
      return $localize`:@@pdfExport.servicesList.tableHeader.partNumber:Sachnummer`;
    case Headers.TOTAL_PRICE:
      return $localize`:@@pdfExport.servicesList.tableHeader.totalPrice:Preis`;
  }
}

interface RowData {
  position: number;
  title: string;
  description: string;
  id: string;
  costs: number;
}

export class ServicesTable {
  readonly columns: TableColumn[];
  readonly rows: ProductListServiceRow[];
  readonly currentCountry: string;

  constructor(pdf: jsPDF, localeId: string, servicesTableRows: RowData[], currentCountry: string) {
    this.columns = [
      new TableColumn(getLocalized(Headers.NUMBER), 60, 96),
      new TableColumn(getLocalized(Headers.TITLE), 180, 196),
      new TableColumn(getLocalized(Headers.DESCRIPTION), 460, 610),
      new TableColumn(getLocalized(Headers.ID), 1094, 176),
      new TableColumn(getLocalized(Headers.TOTAL_PRICE), 1440, 146, true),
    ];
    this.currentCountry = currentCountry;

    this.rows = servicesTableRows.map(
      (servicesTableRow) => new ProductListServiceRow(pdf, localeId, this.columns, servicesTableRow, currentCountry),
    );
  }
}
